import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-believinghappy-lifetimewall.jpg`;
const ALT = "Lara sitting cross-legged on a wood floor, laughing, seated small beneath an enormous colorful painted mural of a laughing woman.";

export function LifetimeWall() {
  return (
    <section
      data-testid="believing-happy-lifetimewall-section"
      className="relative bg-[#FAFAF8]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-[33px] md:pt-[46px] pb-[44px] md:pb-[62px]">
        {/* Nearly full-width image, natural aspect ratio preserved exactly
            (23:11 container matches the source photo 1:1 — zero crop). Light
            edge-only feather on all sides dissolves into the section bg. */}
        <div className="relative w-full aspect-[23/11] reveal">
          <FeatheredImage
            src={IMG}
            alt={ALT}
            testId="believing-happy-lifetimewall-image"
            objectPosition="center"
            featherLeft={6}
            featherRight={6}
            featherTop={8}
            featherBottom={8}
            className="absolute inset-0"
          />
        </div>

        {/* Text below the photograph — unequal-column editorial split.
            Headline anchored left, body offset right (not centered, no cards). */}
        <div className="mt-14 md:mt-16 grid grid-cols-1 lg:grid-cols-12 gap-x-10 gap-y-8">

          <div className="lg:col-span-5 lg:col-start-1 reveal">
            <h2
              data-testid="believing-happy-lifetimewall-headline"
              className="font-display text-[32px] sm:text-[42px] lg:text-[48px] leading-[1.14] tracking-tight text-[#1C1917]"
            >
              Remember when you used to want things just because you wanted
              them?
            </h2>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <div className="space-y-5 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-xl">
              <p>
                Before every idea needed a five-year plan.
                <br />
                Before hobbies needed to become side hustles.
                <br />
                Before you talked yourself out of things because they
                weren&rsquo;t practical, productive or particularly
                impressive.
              </p>
              <p>
                You followed curiosity because something looked interesting.
                <br />
                You tried things because they sounded fun.
                <br />
                You changed your mind.
                <br />
                You got completely fascinated by something no one else
                understood.
                <br />
                You wondered what would happen if&hellip;
              </p>
              <p className="text-[#1C1917]">
                Somewhere along the way, many of us stopped treating
                curiosity like useful information.
              </p>
            </div>

            <p
              data-testid="believing-happy-lifetimewall-closing-line"
              className="mt-10 font-display text-[28px] sm:text-[34px] lg:text-[38px] leading-[1.2] tracking-tight text-[#159E9A] max-w-xl"
            >
              Maybe it&rsquo;s time to start listening again.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
